// extracted by mini-css-extract-plugin
module.exports = {"listItem":"ProductSpecialOffersAccordion_listItem__2L3iV","productSpecialOffersList":"ProductSpecialOffersAccordion_productSpecialOffersList__kRbfA"};